interface useLocaleType {
  getLocale: (countryIso: string) => ILocalesType;
}

export interface ILocalesType {
  locale: string;
  localeWeb: string;
}

const useLocale = (): useLocaleType => {
  const locales = {
    US: { locale: "en_US", localeWeb: "en-US" },
    MX: { locale: "es_MX", localeWeb: "es-MX" },
    EC: { locale: "es_EC", localeWeb: "es-EC" },
    ID: { locale: "id_ID", localeWeb: "id-ID" },
    BR: { locale: "pt_BR", localeWeb: "pt-BR" },
    ZA: { locale: "en_ZA", localeWeb: "en-ZA" },
    CO: { locale: "es_CO", localeWeb: "es-CO" },
    PE: { locale: "es_PE", localeWeb: "es-PE" },
  };
  const getLocale = (countryIso: string) =>
    locales[countryIso] || { locale: "en_US", localeWeb: "en-US" }; // Default fallback

  return {
    getLocale,
  };
};

export default useLocale;
